module.exports = __webpack_public_path__ + "assets/normal/images/Empty_6.aa65a440.png";